module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "w3-margin-top block"
  }, [_c('div', {
    staticClass: "w3-half"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./img/logo.png")
    }
  })])], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "w3-container gradiant-background",
    on: {
      "click": function($event) {
        return _vm.$refs.subscribe.scrollIntoView({
          behavior: 'smooth'
        })
      }
    }
  }, [_c('h1', {
    staticClass: "w3-xxlarge w3-center"
  }, [_vm._v("\n      Ingyenes felmérés otthonodban!\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "w3-row list-main-container block"
  }, [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('vue-particles', {
    attrs: {
      "particleSize": 7,
      "particlesNumber": 80,
      "linesDistance": 200,
      "linesWidth": 2,
      "moveSpeed": 1.5
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "w3-row"
  }, [_c('div', {
    staticClass: "w3-row reference-container"
  }, [_c('div', {
    staticClass: "block"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "w3-row-padding reference-img-container"
  }, _vm._l((_vm.referenceThumbnails), function(image, imageIndex) {
    return _c('div', [_c('img', {
      attrs: {
        "src": image
      },
      on: {
        "click": function($event) {
          _vm.index = imageIndex
        }
      }
    })])
  }), 0)])]), _vm._v(" "), _c('gallery', {
    attrs: {
      "images": _vm.referenceImages,
      "index": _vm.index,
      "options": {
        displayClass: 'blueimp-gallery-display-fix'
      }
    },
    on: {
      "close": function($event) {
        _vm.index = null
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "subscribe",
    staticClass: "w3-row subscribe-container"
  }, [_c('div', {
    staticClass: "block"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "w3-col m12 l6"
  }, [_c('div', {
    staticClass: "form-container"
  }, [_vm._m(7), _vm._v(" "), _c('form', {
    ref: "form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "w3-section"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    attrs: {
      "type": "text",
      "name": "name",
      "placeholder": "Teljes név",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "w3-section"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.phone),
      expression: "form.phone"
    }],
    attrs: {
      "type": "tel",
      "name": "phone",
      "placeholder": "Telefonszám",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "w3-section"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.email),
      expression: "form.email"
    }],
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": "E-mail cím",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "w3-section"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.zipcode),
      expression: "form.zipcode"
    }],
    attrs: {
      "type": "number",
      "min": "1000",
      "max": "9999",
      "name": "zipcode",
      "placeholder": "Irányítószám",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.zipcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "zipcode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    ref: "grecaptcha",
    staticClass: "g-recaptcha",
    attrs: {
      "data-sitekey": _vm.rcaptSigKey
    }
  }), _vm._v(" "), _c('button-spinner', {
    attrs: {
      "isLoading": _vm.isLoading,
      "disabled": _vm.isLoading,
      "status": _vm.status
    }
  }, [_c('span', [_vm._v("Elküld")])]), _vm._v(" "), _c('vue-toast', {
    ref: "successToast"
  }), _vm._v(" "), _c('vue-toast', {
    ref: "errorToast"
  })], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w3-container w3-half"
  }, [_c('div', {
    staticClass: "w3-right w3-margin-top w3-margin-right"
  }, [_c('div', {
    staticClass: "contact-row uppercase"
  }, [_vm._v("Kérdésed van? Keress minket!")]), _vm._v(" "), _c('div', {
    staticClass: "contact-row"
  }, [_c('img', {
    staticClass: "contact-icon",
    attrs: {
      "src": require("./img/phone.svg")
    }
  }), _vm._v("\n          +36 20 330 0518\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "contact-row"
  }, [_c('img', {
    staticClass: "contact-icon uppercase",
    attrs: {
      "src": require("./img/email.svg")
    }
  }), _vm._v("\n          info@becreative.glass\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w3-container"
  }, [_c('h1', {
    staticClass: "w3-xxlarge w3-center gradiant-text"
  }, [_vm._v("\n      Miért a becreative zuhanyzói?\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w3-row-padding w3-section block"
  }, [_c('div', {
    staticClass: "w3-col m12 l6 w3-container w3-center"
  }, [_c('img', {
    staticClass: "img-shower",
    attrs: {
      "src": require("./img/shower.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "w3-col m12 l6 w3-container card-container"
  }, [_c('div', {
    staticClass: "w3-row w3-center card-row"
  }, [_c('div', {
    staticClass: "w3-half card"
  }, [_c('div', {
    staticClass: "w3-section card-cycle"
  }, [_c('img', {
    staticClass: "icon-white",
    attrs: {
      "src": require("./img/paint-brush.svg")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "icon-gray",
    attrs: {
      "src": require("./img/gray_paint-brush.svg")
    }
  })]), _vm._v(" "), _c('h4', [_vm._v("Egyedülálló design")]), _vm._v(" "), _c('div', {
    staticClass: "card-text"
  }, [_vm._v("\n            A megrendelő elképzelése szerint megvalósított, modern, printelt üvegfelület már a fürdőszobában is\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "w3-half card"
  }, [_c('div', {
    staticClass: "w3-section card-cycle"
  }, [_c('img', {
    staticClass: "icon-white icon-larger",
    attrs: {
      "src": require("./img/safety.svg")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "icon-gray icon-larger",
    attrs: {
      "src": require("./img/gray_safety.svg")
    }
  })]), _vm._v(" "), _c('h4', [_vm._v("Biztonságos üveg")]), _vm._v(" "), _c('div', {
    staticClass: "card-text"
  }, [_vm._v("\n            ESG üvegeinket az előírásoknak megfelelő MSZ EN 12150 szabvány szerint készítjük el\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "w3-row w3-center card-row"
  }, [_c('div', {
    staticClass: "w3-half card"
  }, [_c('div', {
    staticClass: "w3-section card-cycle"
  }, [_c('img', {
    staticClass: "icon-white icon-margin-fix",
    attrs: {
      "src": require("./img/clean.svg")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "icon-gray icon-margin-fix",
    attrs: {
      "src": require("./img/gray_clean.svg")
    }
  })]), _vm._v(" "), _c('h4', [_vm._v("Könnyen tisztítható")]), _vm._v(" "), _c('div', {
    staticClass: "card-text"
  }, [_vm._v("\n            Hagyományos fürdőszobai tisztítószerekkel tisztán tartható, kérésre ClearShield bevonattal ellátva\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "w3-half card"
  }, [_c('div', {
    staticClass: "w3-section card-cycle"
  }, [_c('img', {
    staticClass: "icon-white",
    attrs: {
      "src": require("./img/quality.svg")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "icon-gray",
    attrs: {
      "src": require("./img/gray_quality.svg")
    }
  })]), _vm._v(" "), _c('h4', [_vm._v("Minőségi kivitelezés")]), _vm._v(" "), _c('div', {
    staticClass: "card-text"
  }, [_vm._v("\n            Egyedi méretezés alapján, fürdőszobában alkalmazott szerelvényekkel, precízen beépítve\n          ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w3-margin-top w3-margin-bottom"
  }, [_c('h1', {
    staticClass: "w3-xxlarge w3-center gradiant-text"
  }, [_vm._v("\n        A tökéletes megvalósítás három lépésben\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w3-row-padding list-container"
  }, [_c('div', {
    staticClass: "w3-col m12 l6 w3-container"
  }, [_c('div', {
    staticClass: "w3-col l5 m4 w3-hide-small w3-container list-cycle-container"
  }, [_c('div', {
    staticClass: "list-lines-container"
  }, [_c('img', {
    attrs: {
      "src": require("./img/line.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "list-cycle"
  }, [_vm._v("1.")]), _vm._v(" "), _c('div', {
    staticClass: "list-cycle"
  }, [_vm._v("2.")]), _vm._v(" "), _c('div', {
    staticClass: "list-cycle"
  }, [_vm._v("3.")])]), _vm._v(" "), _c('div', {
    staticClass: "w3-col l7 m6 w3-container"
  }, [_c('div', {
    staticClass: "list-cycle w3-hide-medium w3-hide-large"
  }, [_vm._v("1.")]), _vm._v(" "), _c('div', {
    staticClass: "list-text-container"
  }, [_c('h4', [_vm._v("Ingyenes felmérés")]), _vm._v(" "), _c('p', {
    staticClass: "list-text"
  }, [_vm._v("\n              Miután kitöltötted a lap alján található\n              űrlapot, munkatársunk felveszi\n              veled a kapcsolatot!\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "list-cycle w3-hide-medium w3-hide-large"
  }, [_vm._v("2.")]), _vm._v(" "), _c('div', {
    staticClass: "list-text-container"
  }, [_c('h4', [_vm._v("Árajánlat készítés")]), _vm._v(" "), _c('p', {
    staticClass: "list-text"
  }, [_vm._v("\n              Minden munka más-és más, ezért\n              ügyfeleinknek személyre szabott\n              árajánlatot készítünk.\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "list-cycle w3-hide-medium w3-hide-large"
  }, [_vm._v("3.")]), _vm._v(" "), _c('div', {
    staticClass: "list-text-container"
  }, [_c('h4', [_vm._v("Kivitelezés")]), _vm._v(" "), _c('p', {
    staticClass: "list-text"
  }, [_vm._v("\n              Fontosnak tartjuk ügyfeleink\n              elégedettségét, ezért a kivitelezés során\n              többször is egyeztetünk."), _c('br'), _vm._v(" "), _c('b', [_vm._v("100% elégedettségi garancia")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "w3-col m12 l6 w3-container w3-center"
  }, [_c('img', {
    staticClass: "printed-shower",
    attrs: {
      "src": require("./img/printed_shower.jpg")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w3-container w3-margin"
  }, [_c('h1', {
    staticClass: "w3-xxlarge w3-center gradiant-text"
  }, [_vm._v("\n              Referenciák\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w3-col m12 l6 subscribe-text-container"
  }, [_c('div', {
    staticClass: "subscribe-text1 uppercase"
  }, [_vm._v("Ingyenes")]), _vm._v(" "), _c('div', {
    staticClass: "subscribe-text2 uppercase"
  }, [_vm._v("Felmérés")]), _vm._v(" "), _c('div', {
    staticClass: "subscribe-text3 uppercase"
  }, [_vm._v("Otthonodban!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-text"
  }, [_vm._v("\n            Legyél az elsők között akinek"), _c('br'), _vm._v("\n            ingyenesen elvégezzük a felmérést!\n          ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14c58b0a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LandingPage/View.vue
// module id = 936
// module chunks = 0